const OfflineHeader = () => {
    return (
        <header className="container OfflineHeader">
            <div className="OfflineHeader__Brand">
                <img src="/img/brand/Ztudia-Logotipo-Negro-66x26.png" />
            </div>
        </header>
    )
}

export { OfflineHeader };